import {
  CertStatusActionTypes,
  CertStatusState,
  GET_CERT_STATUS_LIST_FULFILLED
} from './certStatus.types';

export const initialState: CertStatusState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null
};

export default function certStatusReducer(
  state = initialState,
  action: CertStatusActionTypes
): CertStatusState {
  switch (action.type) {
    case GET_CERT_STATUS_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: []
      };
    default: {
      return state;
    }
  }
}
